/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { DxDataGridComponent, DxDataGridModule, DxSelectBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { AllSettingsGrid, AllSettingsRow, SaveSettingsRow, SettingsRowValue } from 'src/app/configuration/models/all-settings-grid';
import { ConfigurationService } from 'src/app/configuration/services/configuration.service';
import { GridService } from 'src/app/shared/grid/grid.service';
import { ToastService, ToastType } from 'src/app/shared/toast/toast.service';
import { CurrentUserService } from 'src/app/user/services';
import { Component, inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CustomItemCreatingEvent } from 'devextreme/ui/select_box';
import { EditingStartEvent } from 'devextreme/ui/data_grid';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoGroupingModule, DxoColumnFixingModule, DxiColumnModule, DxoLookupModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { TenantService } from '../services/tenant.service';
import { GenericModalService, ModalSettingsInput } from 'src/app/shared/generic-modal/generic-modal.service';
import { Password, PasswordComponentValue } from '../../controls/password';

interface DataType {
    id: string;
    display: string;
}

@Component({
    selector: 'ep-configuration-settings',
    templateUrl: './configuration-settings.component.html',
    styleUrls: ['./configuration-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoGroupingModule, DxoColumnFixingModule, DxiColumnModule, DxoLookupModule, DxiButtonModule, DxTemplateModule, DxSelectBoxModule, DxTextBoxModule, Password]
})
export class ConfigurationSettingsComponent implements OnInit {
    private currentUserService = inject(CurrentUserService);
    private tenantService = inject(TenantService);
    private modalService = inject(GenericModalService);
    private toastService = inject(ToastService);
    private configurationService = inject(ConfigurationService);
    private gridService = inject(GridService);

    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

    isLoading = false;
    allowUpdating = false;
    allowAdding = false;
    allowDeleting = false;
    allowShowLog = false;
    allowShowPassword = false;
    isClearPasswordHidden = true;
    allSettings = new AllSettingsGrid();
    allCategories: string[] = [];

    dataTypes: DataType[] = [
        { id: 'Text', display: 'Text' },
        { id: 'Boolean', display: 'Boolean' },
        { id: 'Number', display: 'Number' },
        { id: 'Password', display: 'Password' }
    ];

    ngOnInit(): void {
        this.allowUpdating = this.currentUserService.hasPermission('Settings_Action_Settings_Edit');
        this.allowDeleting = this.currentUserService.hasPermission('Settings_Action_Settings_Delete');
        this.allowAdding = this.currentUserService.hasPermission('Settings_Action_Settings_Create');
        this.allowShowLog = this.currentUserService.hasPermission('Settings_Action_Settings_ShowLog');
        this.allowShowPassword = this.currentUserService.hasPermission('ShowPasswords');
        void this.InitAsync();
    }

    async InitAsync(): Promise<void> {
        await this.refresh(false);
        setTimeout(() => this.expandGroup(['Link']), 500);
    }

    async refresh(showHiddenCatogory: boolean): Promise<void> {
        try {
            this.isLoading = true;

            this.allSettings = await this.configurationService.getAllSettings();

            if (!showHiddenCatogory) {
                this.allSettings.Rows = this.allSettings.Rows.filter(row => row.Category.toLowerCase() !== 'hidden');
            }

            this.expandGroup(['Link']);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.isLoading = false;
        }
    }

    expandGroup(groupkey: string[]) {
        if (!this.dataGrid.instance.isRowExpanded(groupkey)) {
            this.dataGrid.instance.expandRow(groupkey);
        }
    }

    onInitNewRow(e: any): void {
        const row = new AllSettingsRow();
        row.DataType = 'Text';

        for (let index = 0; index < this.allSettings.Environments.length; index++) {
            row.Values[index] = new SettingsRowValue();
        }
        e.data = row;

        this.getCategories();
    }

    onRowInserting = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(this.fixupRowData(e.data), item => this.saveRow(item), e.data);
    };

    onRowUpdating = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(this.fixupRowData({ ...e.key, ...e.newData }), item => this.saveRow(item), e.newData);
    };

    onRowRemoving = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as AllSettingsRow, item => this.deleteRow(item));
    };

    // This method normalizes DevExtreme DataGrid form submission shape back into the domain model (AllSettingsRow). During in-place editing / insertion, individual environment
    // values arrive as ad‑hoc properties named "Values[0]", "Values[1]", … instead of being populated in the Values array. The loop detects those transient properties, moves
    // each into the correct array index, and deletes the temporary property keys so the object matches the domain model.
    fixupRowData(row: any): AllSettingsRow {
        const settingsRow = row as AllSettingsRow;
        const envLength = this.allSettings.Environments.length;
        for (let i = 0; i < envLength; i++) {
            const name = `Values[${i}]`;
            // Only proceed if the ad-hoc property actually exists on the object
            if (Object.prototype.hasOwnProperty.call(settingsRow, name)) {
                settingsRow.Values[i] = (settingsRow as any)[name];
                delete (settingsRow as any)[name];
            }
        }
        // Return a row whose Values[] array is now correctly populated
        return settingsRow;
    }

    async saveRow(row: AllSettingsRow): Promise<AllSettingsRow> {
        const saveSettings = new SaveSettingsRow();
        saveSettings.Environments = this.allSettings.Environments;
        saveSettings.Row = row;
        const newSaveSettings = await this.configurationService.saveSettingsRow(saveSettings, false);
        this.toastService.showToast('Setting saved...', ToastType.success);
        return newSaveSettings.Row;
    }

    async deleteRow(row: AllSettingsRow): Promise<AllSettingsRow> {
        await this.configurationService.deleteAllSettingsRow(row.SettingsId, false);
        this.toastService.showToast('Setting deleted...', ToastType.success);
        return row;
    }

    onCellValueChange(value: string | PasswordComponentValue, cell: any): void {
        const isPasswordComponentValue = (v: unknown): v is PasswordComponentValue => !!v && typeof v === 'object' && 'value' in (v as any);
        const newValue: SettingsRowValue = isPasswordComponentValue(value)
            ? { Value: value.id ?? null, SecretId: value.id ?? null, SecretValue: value.value ?? null } // Grid prefers null over undefined
            : { Value: value, SecretId: null, SecretValue: null };
        cell.setValue(newValue);
    }

    onEditingStart(_e: EditingStartEvent) {
        this.getCategories();
    }

    getCategories() {
        this.allCategories = [...new Set(this.allSettings.Rows.map(item => item.Category))];
        this.allCategories.sort();
    }

    addCustomCategory(data: CustomItemCreatingEvent) {
        if (!data.text) {
            data.customItem = null;
            return;
        }
        data.customItem = data.text;
        this.allCategories.push(data.text);
    }

    setCellValue = async (newData: any, value: any, currentRowData: any): Promise<void> => {
        if (value !== currentRowData.DataType) { // If dataType did change
            newData.DataType = value;
            newData.Values = [];

            const data = await this.configurationService.getAllSettings();
            const currentDbRow = data.Rows.find(row => row.SettingsId === currentRowData.SettingsId);

            currentRowData.Values.forEach((currentValue: any, index: number) => {
                const name = `Values[${index}]`;
                const newValue = new SettingsRowValue();

                if (currentValue.Value === '' || currentValue.Value === null) { // indicates we are in create
                    newValue.Value = currentRowData[name]?.Value || '';
                } else { // indicates we are in edit
                    newValue.Value = currentValue.Value;
                }

                if (currentRowData[name] !== undefined) {
                    // this is needed for keeping environment values in create view when changing DataType.
                    newData.Values[index] = new SettingsRowValue();
                    newData.Values[index].Value = currentRowData[name].Value;
                }

                // Making sure we clear fields when changing dataType from password. This needs to be based on db values and not currentRowData
                if (currentDbRow?.DataType === 'Password' && value !== 'Password') {
                    newValue.Value = '';
                    newValue.SecretId = '';
                }

                newData[name] = newValue;
                newData.Values[index] = newValue;
            });
        }
    };

    environmentValuesFilterData = (index: number) => {
        const values = this.allSettings.Rows
            .filter(row => row.DataType !== 'Password')
            .map(row => row.Values[index]?.Value)
            .filter((e, index, array) => e && array.indexOf(e) === index)
            .sort((a, b) => a.localeCompare(b))
            .map(e => ({ text: e, value: e }));
        return values;
    };

    private environmentValuesFilterExpressionByIndex = new Map<number, (filterValue: any, operation: string) => any>();

    environmentValuesFilterExpressionFactory(index: number): (filterValue: any, operation: string) => any {
        const existing = this.environmentValuesFilterExpressionByIndex.get(index);
        if (existing) return existing;

        const fn: (filterValue: any, operation: string) => [string, string, any] = (filterValue: any, operation: string) => [`Values[${index}].Value`, operation ?? 'contains', filterValue];
        this.environmentValuesFilterExpressionByIndex.set(index, fn);
        return fn;
    }
}
